import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
    },
    label: {
      marginBottom: theme.spacing(2),
      fontSize: 14,
    },
    dates: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(1),
    },
    error: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    day: {
      flexBasis: '20%',
      minWidth: 70,
      marginRight: 10,
    },
    month: {
      flexBasis: '40%',
      minWidth: 90,
      marginRight: 10,
    },
    year: {
      flexBasis: '30%',
      minWidth: 90,
      marginRight: 10,
    },
    dayMenu: {
      maxHeight: theme.spacing(45),
    },
    yearMenu: {
      maxHeight: theme.spacing(45),
    },
  });

export default styles;
